export default {
  addTimeLog: null,
  timeLogsList: null,
  deleteTimeLog: null,
  timeLogDetails: null,
  updateTimeLog: null,
  updatePatientTimeLog: null,
  latestTimeLog: null,
}